import { useEffect, useRef, useState } from "react";
import { FiArrowLeft, FiCheck, FiDownloadCloud, FiRefreshCw, FiShield, FiAlertCircle, FiSettings } from "react-icons/fi";
import "./updateSettings.css";
import { refreshApp } from "../../services/app-update/appUpdate";

export default function UpdateSettings() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const request = useRef(null);

  useEffect(() => () => request.current?.abort(), []);

  const update = async () => {
    if (request.current) return;
    const controller = new AbortController();
    request.current = controller;
    setBusy(true);
    setError("");
    try {
      await refreshApp({ signal: controller.signal });
    } catch {
      if (!controller.signal.aborted) {
        request.current = null;
        setBusy(false);
        setError("بارگذاری مجدد انجام نشد. دوباره تلاش کنید.");
      }
    }
  };

  return (
    <section dir="rtl" className="update-settings" aria-labelledby="update-settings-title">
      <header className="update-settings__header">
        <p className="update-settings__eyebrow"><FiSettings aria-hidden="true" /> تنظیمات پنل</p>
        <h1 id="update-settings-title">وضعیت بروزرسانی</h1>
        <p className="update-settings__description">آخرین تغییرات پنل را با یک بروزرسانی دریافت کنید.</p>
      </header>
      <div className={`update-settings__card ${busy ? "is-busy" : ""}`} aria-busy={busy}>
        <div className="update-settings__hero">
          <div className="update-settings__symbol" aria-hidden="true"><FiRefreshCw /></div>
          <div>
            <span className="update-settings__badge"><span />{busy ? "در حال بروزرسانی" : "آمادهٔ دریافت تغییرات"}</span>
            <h2>پنل شما، با آخرین تغییرات</h2>
            <p>با دریافت نسخهٔ تازه، تغییرات جدید پنل در دسترس شما قرار می‌گیرد و همین صفحه دوباره باز می‌شود.</p>
          </div>
        </div>
        <div className="update-settings__benefits">
          <span><FiCheck aria-hidden="true" /> دریافت تازهٔ پنل</span>
          <span><FiShield aria-hidden="true" /> حفظ حساب کاربری و تنظیمات</span>
        </div>
        {error && <p role="alert" className="update-settings__error"><FiAlertCircle aria-hidden="true" />{error}</p>}
        <div className="update-settings__actions">
          <button type="button" onClick={update} disabled={busy} className="update-settings__button">
            <FiDownloadCloud aria-hidden="true" />
            <span>{busy ? "در حال دریافت…" : "دریافت بروزترین تغییرات"}</span>
            {!busy && <FiArrowLeft aria-hidden="true" className="update-settings__button-arrow" />}
          </button>
          <p role="status" aria-live="polite" className="update-settings__hint">{busy ? "لطفاً چند لحظه منتظر بمانید…" : "بدون نیاز به ورود مجدد"}</p>
        </div>
      </div>
      <p className="update-settings__footnote">اگر تغییرات جدید را نمی‌بینید، پنل را یک‌بار بروزرسانی کنید.</p>
    </section>
  );
}
